export const COLUMN_WIDTHS = {
  type: 70,
  quantity: 70,
  status: 90,
}
